<div class="drawer-container" [class.active]="isOpen">
  <div class="overlay" [class.active]="isOpen" (click)="onClose()" (keypress)="onKeyPress($event)"></div>
  <div class="drawer-panel" [class.active]="isOpen">
    <div class="drawer-content">
      <ng-container *ngIf="contentTemplate" [ngTemplateOutlet]="contentTemplate"></ng-container>
    </div>
  </div>
</div>
